import polygon from "./polygon.js";
import * as THREE from './vendor/three.min.js';

/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-svg-webgl !*/
 !function(e,n,t){function o(e,n){return typeof e===n}function s(){var e,n,t,s,a,i,u;for(var f in r)if(r.hasOwnProperty(f)){if(e=[],n=r[f],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(t=0;t<n.options.aliases.length;t++)e.push(n.options.aliases[t].toLowerCase());for(s=o(n.fn,"function")?n.fn():n.fn,a=0;a<e.length;a++)i=e[a],u=i.split("."),1===u.length?Modernizr[u[0]]=s:(!Modernizr[u[0]]||Modernizr[u[0]]instanceof Boolean||(Modernizr[u[0]]=new Boolean(Modernizr[u[0]])),Modernizr[u[0]][u[1]]=s),l.push((s?"":"no-")+u.join("-"))}}function a(){return"function"!=typeof n.createElement?n.createElement(arguments[0]):f?n.createElementNS.call(n,"http://www.w3.org/2000/svg",arguments[0]):n.createElement.apply(n,arguments)}var r=[],i={_version:"3.6.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var t=this;setTimeout(function(){n(t[e])},0)},addTest:function(e,n,t){r.push({name:e,fn:n,options:t})},addAsyncTest:function(e){r.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=i,Modernizr=new Modernizr,Modernizr.addTest("svg",!!n.createElementNS&&!!n.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect);var l=[],u=n.documentElement,f="svg"===u.nodeName.toLowerCase();Modernizr.addTest("webgl",function(){var n=a("canvas"),t="probablySupportsContext"in n?"probablySupportsContext":"supportsContext";return t in n?n[t]("webgl")||n[t]("experimental-webgl"):"WebGLRenderingContext"in e}),s(),delete i.addTest,delete i.addAsyncTest;for(var c=0;c<Modernizr._q.length;c++)Modernizr._q[c]();e.Modernizr=Modernizr}(window,document);
// reset window device pixelratio (support IE/edge as well)
window.devicePixelRatio = window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI;

export function doWebGLSupportCheck() {
  var supportExtension = new THREE.WebGLRenderer().context.getExtension('OES_standard_derivatives');
  if (!Modernizr.webgl || window.devicePixelRatio === 1 || !supportExtension) {
    document.getElementById('webgl-plane').className += ' polygon_image';
  } else {
    document.getElementById('webgl-plane').className += ' polygon_webgl';
    polygon.init({resize: true});
  }
};

export function doSVGsupportCheck() {
  if (!Modernizr.svg || detectIE() !== false) {
    var imgs = document.getElementsByTagName('img');
    var svgExtension = /.*\.svg$/;
    var l = imgs.length;
    var replaceableExt = window.devicePixelRatio === 1 ? 'png': '@2x.png';
    for(var i = 0; i < l; i++) {
      if(imgs[i].src.match(svgExtension)) {
        imgs[i].src = imgs[i].src.slice(0, -4) + replaceableExt;
        console.log(imgs[i].src);
      }
    }

    var svg_logo = document.getElementById('animatable_logo');
    svg_logo.parentNode.removeChild(svg_logo);

    var img = document.createElement('img');
    img.width = 210;
    img.src = replaceHighResExt('res/logo.png');

    document.getElementById('logo_container').appendChild(img);
  }
};

/**
* Replaces a 4 length extension (.svg)to a different one
*/
function replaceHighResExt(path) {
  var replaceableExt = window.devicePixelRatio === 1 ? 'png': '@2x.png';
  return path.slice(0, -4) + replaceableExt;
}

/**
* detect IE
* returns version of IE or false, if browser is not Internet Explorer
*/
function detectIE() {
  var ua = window.navigator.userAgent;

  var msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  var trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  var edge = ua.indexOf('Edge/');
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }

  // other browser
  return false;
}
